import { render, staticRenderFns } from "./KosmoSelect.vue?vue&type=template&id=625d2405&scoped=true"
import script from "./KosmoSelect.vue?vue&type=script&lang=js"
export * from "./KosmoSelect.vue?vue&type=script&lang=js"
import style0 from "./KosmoSelect.vue?vue&type=style&index=0&id=625d2405&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625d2405",
  null
  
)

export default component.exports